import { render, staticRenderFns } from "./ExportForms.vue?vue&type=template&id=a8ff199a&scoped=true&"
import script from "./ExportForms.vue?vue&type=script&lang=js&"
export * from "./ExportForms.vue?vue&type=script&lang=js&"
import style0 from "./ExportForms.vue?vue&type=style&index=0&id=a8ff199a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ff199a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8ff199a')) {
      api.createRecord('a8ff199a', component.options)
    } else {
      api.reload('a8ff199a', component.options)
    }
    module.hot.accept("./ExportForms.vue?vue&type=template&id=a8ff199a&scoped=true&", function () {
      api.rerender('a8ff199a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/tools/ExportForms.vue"
export default component.exports